export const getIsOptionSelected = (id: string, selectedIds?: string[]) =>
    selectedIds ? selectedIds.includes(id) : false;
